var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiTableCellOverrides = function (_a) {
    var typography = _a.typography, spacing = _a.spacing, tokens = _a.tokens;
    return {
        styleOverrides: {
            root: __assign({ borderBottom: "1px solid ".concat(tokens.color_border_bold), padding: spacing(2) }, typography.body2),
            head: __assign({ padding: spacing(1, 2), color: tokens.color_fg_bold }, typography.subtitle2),
            paddingNone: {
                padding: 0,
            },
        },
    };
};
